import { useQuery } from "@tanstack/react-query";
import { parse } from "qs";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import DataSvc from "../services/dataSvc";

const MAX_RETRIES = 5;

export const useCategories = (fetchWithoutBlock = false) =>
  useQuery(["categories"], () => DataSvc.getCategories(fetchWithoutBlock));
export const useMunicipalities = (organizationId?: string) =>
  useQuery(["municipalities", organizationId], () => {
    if (organizationId) {
      return DataSvc.getMunicipalities(organizationId);
    }
    return [];
  });
export const useLocationMunis = (
  userId?: number,
  organizationId?: string,
  fetchWithoutBlock = false
) =>
  useQuery(["muniLocations", userId, organizationId], () => {
    if (organizationId && organizationId !== "undefined") {
      return DataSvc.getMunicipalitiesOfLocations(
        organizationId,
        fetchWithoutBlock
      );
    }

    if (userId) {
      return DataSvc.getMunicipalitiesOfUser(userId, fetchWithoutBlock);
    }
    return [];
  });
export const useSearchQuery = () => {
  const { search } = useLocation();
  return useMemo(() => parse(search, { ignoreQueryPrefix: true }), [search]);
};

export const useOrganization = (organizationId?: string | number) => {
  return useQuery(
    ["organization", organizationId],
    () => {
      if (!organizationId) {
        return null;
      }
      return DataSvc.getOrganization({
        organizationId: String(organizationId),
      });
    },
    {
      enabled: !!organizationId,
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    }
  );
};

export const useMe = (noLoading?: boolean) => {
  return useQuery(
    ["me"],
    async () => {
      const me = await DataSvc.getAccountsMe(noLoading);

      DataSvc.checkForForcedLogout();

      return me;
    },
    {
      retry: (failureCount, error: any) => {
        if (
          error.response?.status === 401 ||
          error.response?.status === 403 ||
          failureCount > MAX_RETRIES
        ) {
          return false;
        }
        return true;
      },
    }
  );
};
